import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const DataRetentionSettings: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Data Retention Settings</Title>
      <p>Configure data retention policies and automatic cleanup rules.</p>
      <p>Set retention periods for different types of data.</p>
    </Card>
  );
};

export default DataRetentionSettings; 